import { getHostNameParts } from 'Containers/LandingPages/utils';

export const updSubdomain = (currentSubdomain?: string, newSubdomain?: string) => {
  const hostnameParts = getHostNameParts(window?.location.hostname);

  if (currentSubdomain !== newSubdomain) {
    if (newSubdomain && currentSubdomain) {
      //если поддомен есть и есть новый поддомен, заменяем его
      window.location.href = `https://${newSubdomain}.${hostnameParts?.groups?.hostname}`;
    } else if (currentSubdomain) {
      //если поддомен есть, а нового нет - удаляем
      window.location.href = `https://${hostnameParts?.groups?.hostname}`;
    } else {
      //если поддомена нет, добавляем новый
      window.location.href = `https://${newSubdomain}.${window?.location.hostname}`;
    }
  }
};
